import { render, staticRenderFns } from "./AccountsAndRoles.vue?vue&type=template&id=55070d5d&scoped=true&"
import script from "./AccountsAndRoles.vue?vue&type=script&lang=js&"
export * from "./AccountsAndRoles.vue?vue&type=script&lang=js&"
import style0 from "./AccountsAndRoles.vue?vue&type=style&index=0&id=55070d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55070d5d",
  null
  
)

export default component.exports